/* eslint-disable react/prop-types */
import React from 'react';
import { Link } from 'gatsby';
import links from '../../../nav-config';

import Subnav from './Subnav';

import Home from '../../assets/images/svg/home.svg';
import Payments from '../../assets/images/svg/payments.svg';
import Terminal from '../../assets/images/svg/terminal.svg';
import Transfers from '../../assets/images/svg/transfers.svg';
import Identity from '../../assets/images/svg/identity-verification.svg';
import Tools from '../../assets/images/svg/developer-tools.svg';
import Libraries from '../../assets/images/svg/libraries-plugins.svg';
import Guides from '../../assets/images/svg/guides.svg';

import Cancel from '../../assets/images/svg/cancel.svg';
import DoubleArrow from '../../assets/images/svg/double-arrow.svg'

import './nav.scss';

const Nav = ({toggleNav}) => {

	const getIcon = title => {
		const icons = {
			home: <Home />,
			payments: <Payments />,
			terminal: <Terminal />,
			transfers: <Transfers />,
			identity: <Identity />,
			developer: <Tools />,
			libraries: <Libraries />,
			guides: <Guides />,
		};

		return title ? icons[title.toLowerCase().split(' ')[0]] : '';
	};

	const getKey = route => {
		return route.replaceAll("/", "_")
	}

	const toggleMenu = ({ isPartiallyCurrent }) => {
		return isPartiallyCurrent
			? { className: 'nav__link nav__link--active' }
			: null;
	}

	return (
		<div className="nav">
			<div className="nav__header">
				<button className="button button--secondary" onClick={toggleNav}>
					<Cancel className="button__icon" />
					<span>Close</span>
				</button>
			</div>
			<div className="nav__main">
				<ul className="nav__menu">
					{links.map(link => (
						<li className="nav__item" key={getKey(link.route)}>
							{link.route === '/' ? (
								<Link
									to={link.route}
									className="nav__link"
									activeClassName="nav__link--active"
								>
									<span className="nav__icon">
										{getIcon(link.title)}
									</span>
									<span>{link.title}</span>
								</Link>
							): (
								<Link
									to={link.route}
									className="nav__link"
									getProps={toggleMenu}
								>
									<span className="nav__icon">
										{getIcon(link.title)}
									</span>
									<span>{link.title}</span>
								</Link>
							)}
							{link.children.length > 0 && (
								<Subnav sublinks={link.children} />
							)}
						</li>
					))}
				</ul>
				<div className="nav__extra">
					<Link to="/changelog/api"
						partiallyActive={true}
						className="nav__link nav__link--secondary"
						activeClassName="nav__link--active">
						API Changelog
					</Link>
				</div>
			</div>
			<div className="nav__footer">
				<Link className="nav__text" to="/api">
					<span>See API Reference</span>
					<DoubleArrow />
				</Link>
			</div>
		</div>
	);
}

export default Nav;
